export default __webpack_public_path__ + "static/media/first-right-img.5e9feb5a.png";